<template>
  <div>
    <template v-if="viaje.id">
      <!-- CARD PERSONA -->
      <template v-for="(reserva, index) in resumenReservas" :key="reserva.id">
        <div class="card-persona mb-10">
          <div
            class="persona-header d-flex align-items-center justify-content-between pl-15 pr-15 py-3 bg-primary-light"
            :class="{ collapsed: isCollapsed[index] }"
            @click="toggleCollapse(index)">
            <div class="d-flex align-items-center">
              <div class="icono-persona me-2">
                <IconOccupied
                  :user="reserva.usuario && reserva.usuario.nombre ? reserva.usuario : getUserForIcon(index)"
                  :all-colors="true"
                  :thin-border="true" />
              </div>
              <span class="fs-16 fw-medium text-primary">
                <template v-if="reserva.usuario && reserva.usuario.nombre">
                  {{ reserva.usuario.nombre }} {{ reserva.usuario.apellido }}
                </template>
                <template v-else> {{ $t('general.persona') }} {{ index + 1 }}/{{ resumenReservas.length }} </template>
              </span>
            </div>
            <CustomIcon
              :icon="isCollapsed[index] ? arrowDownIcon : arrowUpIcon"
              size="14px"
              class="pointer text-primary" />
          </div>

          <transition name="collapse">
            <div v-show="!isCollapsed[index]" class="collapse-content">
              <!-- SERVICIOS INCLUIDOS -->
              <div class="p-15 text-primary">
                <div class="d-flex justify-content-between align-items-center mb-10">
                  <span class="fs-13 fw-bold">{{ $t('input.field.incluidPaqueteBasico') }}</span>
                  <span class="fs-13 fw-bold text-primary">
                    <template v-if="reserva.precioBasico && reserva.precioBasico > 0">
                      {{ formatPrice(reserva.precioBasico) }} {{ agenciaStore.getCurrency }}
                    </template>
                    <template
                      v-else-if="storeHabitacion.calculaPrecioBaseGrupo && storeHabitacion.calculaPrecioBaseGrupo > 0">
                      {{ formatPrice(storeHabitacion.calculaPrecioBaseGrupo) }} {{ agenciaStore.getCurrency }}
                    </template>
                  </span>
                </div>
                <!-- ALOJAMIENTO -->
                <template v-if="alojamiento">
                  <div class="servicio-item mb-10 text-primary">
                    <div class="d-flex align-items-start">
                      <CustomIcon :icon="accommodationIcon" size="14px" class="me-2 flex-shrink-0 text-primary" />
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center">
                          <div class="fs-13 me-2 title-servicio">{{ alojamiento.nombre }}</div>
                          <a
                            href="#"
                            class="text-primary fs-13 text-decoration-underline pointer title-servicio"
                            @click.prevent="goToAlojamiento(alojamiento.id)">
                            + {{ $t('general.info') }}
                          </a>
                        </div>
                        <div class="descripcion-servicio fs-11 text-primary-light">
                          {{ alojamiento.descripcion }}
                        </div>
                        <div class="fs-11 text-primary-light">
                          {{ getAlojamientoInfo(alojamiento) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- SERVICIOS INCLUIDOS -->
                <template v-for="incluido in incluyeFiltrado" :key="incluido.nombre">
                  <div class="servicio-item mb-10 text-primary">
                    <div class="d-flex align-items-start">
                      <img
                        v-if="incluido.imagen"
                        :src="incluido.imagen"
                        class="servicio-icon text-primary"
                        :alt="incluido.nombre" />
                      <CustomIcon v-else :icon="activityIcon" class="servicio-icon text-primary" size="14px" />
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center">
                          <div class="fs-13 translate me-2">{{ incluido.nombre }}</div>
                        </div>
                        <div
                          v-if="incluido.descripcion"
                          class="descripcion-servicio fs-11 text-primary-light translate">
                          {{ incluido.descripcion }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- SERVICIOS DEL PAQUETE BASICO -->
                <template v-for="swc in getServiciosPaqueteBasico(reserva)" :key="swc.servicio.id">
                  <div class="servicio-item mb-10 text-primary">
                    <div class="d-flex align-items-start">
                      <template v-if="getServiceIcon(swc.servicio).type === 'image'">
                        <img
                          :src="getServiceIcon(swc.servicio).value"
                          class="servicio-icon text-primary"
                          :alt="swc.servicio.nombre" />
                      </template>
                      <template v-if="getServiceIcon(swc.servicio).type === 'icon'">
                        <CustomIcon
                          :icon="getServiceIcon(swc.servicio).value"
                          class="servicio-icon text-primary"
                          size="14px" />
                      </template>
                      <div class="flex-grow-1">
                        <div class="d-flex align-items-center">
                          <div class="fs-13 translate me-2 title-servicio">{{ swc.servicio.nombre }}</div>
                          <a
                            v-if="swc.servicio.infoExtra"
                            href="#"
                            class="text-primary fs-13 text-decoration-underline pointer title-servicio"
                            data-bs-toggle="modal"
                            :data-bs-target="`#infoExtraModalPB${reserva.id}-${swc.servicio.id}`"
                            @click.prevent.stop>
                            + {{ $t('general.info') }}
                          </a>
                        </div>
                        <div
                          v-if="swc.servicio.descripcion"
                          class="descripcion-servicio fs-11 text-primary-light translate">
                          {{ swc.servicio.descripcion }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <div class="divisor-horizontal ml-15 mr-15" />

              <!-- SERVICIOS EXTRAS -->
              <template v-if="getServiciosExtras(reserva).length > 0">
                <div class="p-15 text-primary">
                  <div class="fs-13 fw-bold mb-10">{{ $t('reserva.extras') }}</div>

                  <template v-for="swc in getServiciosExtras(reserva)" :key="swc.servicio.id">
                    <div class="servicio-item mb-10 text-primary">
                      <div class="d-flex align-items-start justify-content-between">
                        <div class="d-flex align-items-start flex-grow-1">
                          <template v-if="getServiceIcon(swc.servicio).type === 'image'">
                            <img
                              :src="getServiceIcon(swc.servicio).value"
                              class="servicio-icon"
                              :alt="swc.servicio.nombre" />
                          </template>
                          <template v-if="getServiceIcon(swc.servicio).type === 'icon'">
                            <CustomIcon :icon="getServiceIcon(swc.servicio).value" class="servicio-icon" size="14px" />
                          </template>
                          <div class="flex-grow-1">
                            <div class="d-flex align-items-center">
                              <div class="fs-13 translate me-2 title-servicio">{{ swc.servicio.nombre }}</div>
                              <a
                                v-if="swc.servicio.infoExtra"
                                href="#"
                                class="text-primary fs-13 text-decoration-underline pointer title-servicio"
                                data-bs-toggle="modal"
                                :data-bs-target="`#infoExtraModalExtra${reserva.id}-${swc.servicio.id}`"
                                @click.prevent.stop>
                                + {{ $t('general.info') }}
                              </a>
                            </div>
                            <div
                              v-if="swc.servicio.descripcion"
                              class="descripcion-servicio fs-11 text-primary-light translate">
                              {{ swc.servicio.descripcion }}
                            </div>
                            <div
                              v-if="swc.servicio.firstFilter || swc.servicio.secondFilter"
                              class="fs-11 text-primary-light">
                              {{ swc.servicio.firstFilter.nombre }} / {{ swc.servicio.secondFilter.nombre }}
                            </div>
                          </div>
                        </div>
                        <div class="fs-13 d-flex align-items-center">
                          <span class="fw-normal me-1">
                            {{ swc.servicio.paqueteBasico ? swc.cantidad - 1 : swc.cantidad }} x
                          </span>
                          <span class="fw-bold">
                            {{ formatPrice(calculaPrecioForServicioWithCantidad(swc, false)) }}
                            {{ agenciaStore.getCurrency }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>

                <div class="divisor-horizontal ml-15 mr-15" />
              </template>

              <!-- TASAS -->
              <div class="p-15 text-primary">
                <div
                  v-if="reserva.precioBase > 0"
                  class="d-flex justify-content-between align-items-center"
                  :class="{
                    'mb-2':
                      storeHabitacion.getCodigoDescuento ||
                      reserva.tasasExternasCalculadas?.filter(t => t.importe > 0)?.length > 0 ||
                      reserva.tasasInternasCalculadas?.filter(t => t.importe > 0)?.length > 0,
                  }">
                  <span class="fs-13 fw-bold">{{ $t('subtitulo.total').toUpperCase() }}</span>
                  <span class="fs-13 fw-bold"
                    >{{ formatPrice(reserva.precioBase) }} {{ agenciaStore.getCurrency }}</span
                  >
                </div>
                <!-- DESCUENTOS -->
                <template v-if="storeHabitacion.getCodigoDescuento">
                  <div class="fs-13 fw-bold mb-1">{{ $t('reserva.descuento') }}</div>
                  <div class="d-flex justify-content-between align-items-center mb-2">
                    <div class="fs-11 text-primary-light">
                      {{ storeHabitacion.getCodigoDescuento.descripcion }}
                      <button type="button" class="btn-link-delete ms-1" @click="limpiarCodigo">
                        {{ $t('actions.delete') }}
                      </button>
                    </div>
                    <span class="fs-13 fw-bold text-secondary">
                      -{{ formatPrice(reserva.descuento) }} {{ agenciaStore.getCurrency }}
                    </span>
                  </div>
                </template>
                <template
                  v-for="tasaExterna in reserva.tasasExternasCalculadas?.filter(t => t.importe > 0)"
                  :key="tasaExterna">
                  <div
                    class="d-flex justify-content-between align-items-center"
                    :class="{ 'mb-2': reserva.tasasInternasCalculadas?.filter(t => t.importe > 0)?.length > 0 }">
                    <span class="fs-13 fw-bold">{{ $t(`reserva.tasas.externas.${tasaExterna.codigo}`) }}</span>
                    <span class="fs-13 fw-bold"
                      >{{ formatPrice(tasaExterna.importe) }} {{ agenciaStore.getCurrency }}</span
                    >
                  </div>
                </template>

                <template
                  v-for="tasaInterna in reserva.tasasInternasCalculadas?.filter(t => t.importe > 0)"
                  :key="tasaInterna">
                  <div class="d-flex justify-content-between align-items-center">
                    <span class="fs-13 fw-bold">{{ $t(`reserva.tasas.internas.${tasaInterna.codigo}`) }}</span>
                    <span class="fs-13 fw-bold"
                      >{{ formatPrice(tasaInterna.importe) }} {{ agenciaStore.getCurrency }}</span
                    >
                  </div>
                </template>
              </div>
            </div>
          </transition>
        </div>
      </template>

      <!-- IMPORTE TOTAL -->
      <div class="card-total-final p-15">
        <div class="d-flex justify-content-between align-items-center">
          <span class="fs-16 fw-bold text-white">{{ $t('subtitulo.importeTotal').toUpperCase() }}</span>
          <span class="fs-23 fw-bold text-white fs-m-16 fw-m-semibold">
            {{ formatPrice(calculaPrecioTotalReservas(resumenReservas)) }} {{ agenciaStore.getCurrency }}
          </span>
        </div>
      </div>
    </template>

    <!-- MODALES -->
    <Teleport to="body">
      <template v-for="reserva in resumenReservas" :key="`reserva-${reserva.id}`">
        <template
          v-for="swc in getServiciosPaqueteBasico(reserva).filter(s => s.servicio.infoExtra)"
          :key="`modal-pb-${swc.servicio.id}`">
          <InfoExtraModal
            :modal-id="`infoExtraModalPB${reserva.id}-${swc.servicio.id}`"
            :title="swc.servicio.nombre"
            :content="swc.servicio.infoExtra" />
        </template>
        <template
          v-for="swc in getServiciosExtras(reserva).filter(s => s.servicio.infoExtra)"
          :key="`modal-extra-${swc.servicio.id}`">
          <InfoExtraModal
            :modal-id="`infoExtraModalExtra${reserva.id}-${swc.servicio.id}`"
            :title="swc.servicio.nombre"
            :content="swc.servicio.infoExtra" />
        </template>
      </template>
    </Teleport>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';
  import moment from 'moment';
  import { calculaPrecioForServicioWithCantidad, calculaPrecioTotalReservas } from '@/helpers/viajesGrupos';
  import { formatPrice } from '@/helpers/numberUtils';
  import { getCategoriasServiciosMetaData } from '@/helpers/serviciosUtils';
  import accommodationIcon from '@/assets/icons/alojamiento.svg';
  import IconOccupied from '@/components/Icons/IconOccupied.vue';
  import CustomIcon from '@/components/CustomIcon.vue';
  import arrowDownIcon from '@/assets/icons/arrow_down.svg';
  import arrowUpIcon from '@/assets/icons/arrow_up.svg';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { agenciaStoreModule } from '@/store_pinia/agencia';
  import InfoExtraModal from '@/components/modales/InfoExtraModal.vue';
  import activityIcon from '@/assets/icons/servicios/actividad.svg';

  const { t } = useI18n();
  const storeHabitacion = informacionHabitacion();
  const agenciaStore = agenciaStoreModule();
  const isCollapsed = ref([]);

  const emit = defineEmits(['limpiar-codigo-descuento', 'descuento-aplicado']);

  const viaje = computed(() => storeHabitacion.getViaje);
  const alojamiento = computed(() => storeHabitacion.getAlojamiento);
  const resumenReservas = computed(() => storeHabitacion.getResumenReservas);

  const incluyeFiltrado = computed(() => {
    if (viaje.value.incluyes && viaje.value.incluyes.length > 0) {
      return viaje.value.incluyes
        .filter(({ nombre }) => nombre.toLowerCase() !== 'alojamiento')
        .filter(({ isIconoViaje }) => isIconoViaje);
    }
    return [];
  });

  function toggleCollapse(index) {
    isCollapsed.value[index] = !isCollapsed.value[index];
  }

  function getUserForIcon(index) {
    return {
      nombre: t('general.persona'),
      apellido: `${index + 1}/${resumenReservas.value.length}`,
      done: false,
      isFree: false,
      id: index + 1,
    };
  }

  function getServiciosPaqueteBasico(reserva) {
    return reserva.serviciosWithCantidad?.filter(swc => swc.servicio.paqueteBasico) || [];
  }

  function getServiciosExtras(reserva) {
    return (
      reserva.serviciosWithCantidad?.filter(
        swc => !swc.servicio.nulo && (!swc.servicio.paqueteBasico || swc.cantidad > 1)
      ) || []
    );
  }

  function getServiceIcon(servicio) {
    const agrupacionesServicios = storeHabitacion.getAgrupacionesServicios;
    const agrupacionServicios = agrupacionesServicios.find(agrupacion => agrupacion.id === servicio.agrupacion?.id);

    if (!agrupacionServicios) {
      return { type: 'image', value: '' };
    }

    if (agrupacionServicios.icono) {
      return { type: 'image', value: agrupacionServicios.icono };
    } else {
      const serviciosMetaData = getCategoriasServiciosMetaData().find(
        ({ selector }) => selector === agrupacionServicios.tipo
      );
      if (serviciosMetaData?.icono) {
        return { type: 'icon', value: serviciosMetaData.icono };
      }
    }
  }

  function getAlojamientoInfo(alojamiento) {
    const info = [];

    if (viaje.value.fechaInicio && viaje.value.fechaFin) {
      const inicio = moment(viaje.value.fechaInicio);
      const fin = moment(viaje.value.fechaFin);
      const noches = fin.diff(inicio, 'days');
      const nochesText = noches === 1 ? t('general.noche') : t('general.noches');
      info.push(`${noches} ${nochesText}`);
    }

    if (alojamiento.habitacion?.tipo?.nombre) {
      info.push(alojamiento.habitacion.tipo.nombre);
    }

    if (alojamiento.habitacion?.regimen) {
      const regimen = t(`reserva.tipo.${alojamiento.habitacion.regimen}`);
      info.push(regimen);
    }

    return info.join(' / ');
  }

  function goToAlojamiento(alojamientoId) {
    const url = `/alojamientos/${alojamientoId}`;
    window.open(url, '_blank');
  }

  function limpiarCodigo() {
    emit('limpiar-codigo-descuento');
  }

  onMounted(() => {
    isCollapsed.value = resumenReservas.value.map(() => false);
  });
</script>

<style lang="scss" scoped>
  .card-persona {
    border-radius: var(--bs-border-radius-xl);
    border: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    background: white;

    .persona-header {
      background-color: rgba(var(--bs-primary-rgb), 0.1);
      border-top-left-radius: var(--bs-border-radius-xl);
      border-top-right-radius: var(--bs-border-radius-xl);

      &.collapsed {
        border-bottom-left-radius: var(--bs-border-radius-xl);
        border-bottom-right-radius: var(--bs-border-radius-xl);
      }

      .icono-persona {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;

        .icono-ocupado {
          width: 24px !important;
          height: 24px !important;
          font-size: 12px !important;
          border-width: 1px !important;
        }
      }
    }

    .servicio-item {
      .servicio-icon {
        width: 14px;
        height: 14px;
        font-size: 14px;
        margin-right: 8px;
        margin-top: 2px;
        flex-shrink: 0;
      }

      .descripcion-servicio {
        margin-bottom: 3px;
      }

      &:last-child {
        margin-bottom: 0 !important;
      }
    }

    .divisor-horizontal {
      border-top: 1px solid rgba(var(--bs-primary-rgb), 0.2);
    }
  }

  .card-total-final {
    background-color: var(--bs-primary);
    border-radius: var(--bs-border-radius-xl);
  }

  .text-primary-light {
    color: rgba(var(--bs-primary-rgb), 0.8);
  }

  .collapse-enter-active,
  .collapse-leave-active {
    transition: all 0.3s ease;
  }

  .collapse-enter-from,
  .collapse-leave-to {
    opacity: 0;
    max-height: 0;
  }

  .collapse-enter-to,
  .collapse-leave-from {
    opacity: 1;
    max-height: 1000px;
  }

  .title-servicio {
    margin-bottom: 3px !important;
  }

  .btn-link-delete {
    background: none;
    border: none;
    color: var(--bs-primary);
    font-size: 11px;
    font-weight: 400;
    text-decoration: underline;
    cursor: pointer;
    padding: 0;
  }

  .codigo-descuento-container {
    background-color: rgba(var(--bs-primary-rgb), 0.05);
    border-radius: var(--bs-border-radius-xl);
    margin-top: 10px;
  }
</style>
